export class SRCSampleDTO {
    barcode: string;
    bottomBarcode: string;
    trayID: string;
    removed: string;
}